import {
  faEarListen,
  faBookOpen,
  faPencil,
  faKeynote,
} from "@fortawesome/pro-regular-svg-icons";

const getIconFromCategoryString = (category) => {
  switch (category) {
    case "Listening":
      return faEarListen;
    case "Reading":
      return faBookOpen;
    case "Writing":
      return faPencil;
    case "Speaking":
      return faKeynote;
    default:
      return null;
  }
};

export default getIconFromCategoryString;
